
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySnowShowersNightColour as ObiLightningHeavySnowShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-snow-showers-night-colour.js';
 
 
 

 
 export const ObiLightningHeavySnowShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-snow-showers-night-colour',
   elementClass: ObiLightningHeavySnowShowersNightColourElement,
   events: {
     
   }
  });
 
 